import { useMemo, useState, useCallback } from "react";
import { GeoPreviewMapProps, GeoPreviewMapViewModel, FeaturePopupData } from "./GeoPreviewMap.types";
import { processFeatures } from "./GeoPreviewMap.helpers";

export function useGeoPreviewMapViewModel(props: GeoPreviewMapProps): GeoPreviewMapViewModel {
	const [activePopup, setActivePopup] = useState<FeaturePopupData | null>(null);

	const handleMapClick = useCallback(() => {
		setActivePopup(null);
	}, []);

	const onFeatureClick = useCallback((lngLat: { lng: number; lat: number }, properties: Record<string, unknown>) => {
		setActivePopup({ lngLat, properties });
	}, []);

	const processedFeatures = useMemo(() => {
		return processFeatures(props.inputData, props.groupIndex);
	}, [props.inputData, props.groupIndex]);

	return {
		activePopup,
		processedFeatures,
		onFeatureClick,
		handleMapClick,
	};
}
